import React, { useEffect, useState } from 'react';

// Matches MobileAppPreview's PreviewModules convention: `any` here sidesteps a
// setState-with-function-value inference clash against the ambient module's
// declared props (native-app-preview.d.ts) — the real props are still checked
// at the JSX call site.
type ContentManagementRendererType = React.ComponentType<any>;

/**
 * Loads the ACTUAL native app Table renderer (the same `NativeAppPreview/ContentManagement`
 * alias MobileAppPreview uses for its device-frame preview), so an inline mobile-view
 * preview is pixel-accurate to the app rather than a hand-rolled mock-up. Returns `null`
 * until the async import resolves.
 */
export function useNativeContentManagementRenderer(): ContentManagementRendererType | null {
  const [Renderer, setRenderer] = useState<ContentManagementRendererType | null>(null);

  useEffect(() => {
    let cancelled = false;
    import('NativeAppPreview/ContentManagement').then((mod) => {
      if (!cancelled) setRenderer(() => mod.ContentManagementRenderer);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return Renderer;
}
